import { render } from "./ReleasePopup.vue?vue&type=template&id=16513546"
import script from "./ReleasePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleasePopup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/ReleaseFeatures/ReleasePopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16513546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16513546', __exports__)) {
    api.reload('16513546', __exports__)
  }
  
  module.hot.accept("./ReleasePopup.vue?vue&type=template&id=16513546", () => {
    api.rerender('16513546', render)
  })

}


export default __exports__